"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalStorageEvents = exports.LocalStorageItems = void 0;
var LocalStorageItems;

(function (LocalStorageItems) {
  LocalStorageItems["JOB_QUEUE_CHECKOUT"] = "job_queueCheckout";
  LocalStorageItems["TOKEN"] = "token";
  LocalStorageItems["CSRF_TOKEN"] = "csrf_token";
  LocalStorageItems["CHECKOUT"] = "data_checkout";
  LocalStorageItems["PAYMENT"] = "data_payment";
})(LocalStorageItems = exports.LocalStorageItems || (exports.LocalStorageItems = {}));

var LocalStorageEvents;

(function (LocalStorageEvents) {
  LocalStorageEvents["CLEAR"] = "clear";
})(LocalStorageEvents = exports.LocalStorageEvents || (exports.LocalStorageEvents = {}));